import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CasinoTagsEnum,
  HOME_ROUTE,
  ICasinoGame,
  INT_CASINO_ROUTE,
} from "@hypexone/uicore";
import FantasySportsSection from "../../components/home/FantasySportsSection";

interface HomeGamesProps {
  casinoGames: ICasinoGame[]
  isLoggedIn: boolean;
  showPopUp: () => void;
}

const HomeGames: React.FC<HomeGamesProps> = ({ casinoGames, isLoggedIn, showPopUp }) => {
  const [trendingGames, setTrendingGames] = useState<ICasinoGame[]>([]);
  const [fantasyGames, setFantasyGames] = useState<ICasinoGame[]>([]);
  const [newLaunchGames, setNewLaunchGames] = useState<ICasinoGame[]>([]);
  const [recommendedGames, setRecommendedGames] = useState<ICasinoGame[]>([]);
  const [liveCasinoGames, setLiveCasinoGames] = useState<ICasinoGame[]>([]);
  const [slotsGames, setSlotsGames] = useState<ICasinoGame[]>([]);
  const navigate = useNavigate();

  let loggedInUserStatus;
  if (isLoggedIn) {
    loggedInUserStatus = JSON.parse(
      window.atob(sessionStorage.getItem("jwt_token").split(".")[1])
    ).status;
  }

  useEffect(() => {
    if (casinoGames.length > 0) {
    filterGames();
    }
  }, [casinoGames]);

  const getGameUrl = async (
    gameId: string,
    gameName: string,
    gameCode: string,
    provider: string,
    subProvider: string,
    superProvider: string,
    sectionCategory: string
  ) => {
    if (isLoggedIn) {
      // status check
      if (loggedInUserStatus === 0 || loggedInUserStatus === 3) {
        navigate(HOME_ROUTE);
      }
      if (provider === "Indian Casino") {
        navigate(`/casino/indian/${gameCode}`);
      } else if (gameId == null) {
        navigate({
          pathname: INT_CASINO_ROUTE,
          search: `?subProvider=${encodeURIComponent(provider)}&category=${sectionCategory ? encodeURIComponent(sectionCategory) : 'ALL'}`,
        });
      } else {
        navigate(
          `/dc/gamev1.1/${gameName?.toLowerCase().replace(/\s+/g, "-")}-${btoa(
            gameId?.toString()
          )}-${btoa(gameCode)}-${btoa(provider)}-${btoa(subProvider)}-${btoa(
            superProvider
          )}`,
          { state: { gameName } }
        );
      }
    } else {
      showPopUp();
      return;
    }
  };

  const filterGames = async () => {
    const trending = casinoGames?.filter(
      (game) => game.sectionCode === 'trending_games'
    );
    const newLaunch = casinoGames?.filter(
      (game) => game.sectionCode === CasinoTagsEnum.NEW_LAUNCH
    );
    const recommended = casinoGames?.filter(
      (game) => game.sectionCode === CasinoTagsEnum.RECOMMENDED_GAMES
    );
    const liveCasino = casinoGames?.filter(
      (game) => game.sectionCode === CasinoTagsEnum.LIVE_CASINO_GAMES
    );
    const slots = casinoGames?.filter(
      (game) => game.sectionCode === CasinoTagsEnum.SLOTS
    );
    const fantasy = casinoGames?.filter(
      (game) => game.sectionCode === 'fantasy_sports'
    );
    setFantasyGames(fantasy);
    setTrendingGames(trending);
    setNewLaunchGames(newLaunch);
    setRecommendedGames(recommended);
    setLiveCasinoGames(liveCasino);
    setSlotsGames(slots);
  };

  const GameCard = ({ game }: { game: ICasinoGame }) => (
    <div className="flex flex-col flex-shrink-0 w-[33%] md:w-[20%] lg:w-[14.28%] xl:w-[10%] h-[160px] md:h-[180px] max-h-[160px] md:max-h-[180px]">
      <div className="flex-1 overflow-hidden">
      <img
        loading="lazy"
        src={game.sectionImage || game.trendingThumbnail || game.urlThumb}
        alt={game.gameName}
        className="w-full h-full cursor-pointer"
        onClick={() =>
          getGameUrl(
            game.gameId,
            game.gameName,
            game.gameCode,
            game.providerName,
            game.subProviderName,
            game.superProviderName,
            game.sectionCategory
          )
        }
      />
    </div>
      {/* <div className="flex items-center justify-center text-center text-[#fff] bg-black w-full h-[32px] sm:h-[24px] cursor-pointer p-[5px] text-[11px] font-bold flex-shrink-0">
        <span className="truncate w-full">{game.gameName}</span>
      </div> */}
    </div>
    );

  const CategorySection = ({
    title,
    games,
  }: {
    title: string;
    games: ICasinoGame[];
  }) => (
    <div className="flex flex-col gap-0.5">
      <h2
        style={{
          background: "linear-gradient(-180deg, #F72424 0%, #BB1C00 100%)",
        }}
        className="text-[13px] md:text-[16px] px-1.5 py-1 text-white"
      >
        {title}
      </h2>
      <div className="flex items-center gap-1 overflow-x-auto hide-scrollbar">
        {games?.map((game, gameIndex) => (
          <GameCard key={game.gameId + gameIndex} game={game} />
        ))}
      </div>
    </div>
  );

  return (
    <div className="flex flex-col gap-0.5">
      {fantasyGames.length > 0 && (
        <FantasySportsSection games={fantasyGames} />
      )}
      {newLaunchGames.length > 0 && (
        <CategorySection title="NEW LAUNCH" games={newLaunchGames} />
      )}
      {trendingGames.length > 0 && (
        <CategorySection title="TRENDING GAMES" games={trendingGames} />
      )}
      {recommendedGames.length > 0 && (
        <CategorySection title="RECOMMENDED GAMES" games={recommendedGames} />
      )}
      {liveCasinoGames.length > 0 && (
        <CategorySection title="LIVE CASINO GAMES" games={liveCasinoGames} />
      )}
      {slotsGames.length > 0 && (
        <CategorySection title="SLOTS" games={slotsGames} />
      )}
    </div>
  );
};

export default HomeGames;
